import { Pipe, PipeTransform } from '@angular/core';
import { RenderableCell } from 'src/app/element-handling/types';
import { getSpan } from './rowspan.pipe';

@Pipe({
  name: 'colspan',
  standalone: true
})
export class ColspanPipe implements PipeTransform {
  public transform(cell: RenderableCell): number {
    return getSpan(cell, 'colspan');
  }
}
